import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, Inject, PLATFORM_ID, ChangeDetectionStrategy} from '@angular/core';
import {CmsService} from '../../shared/services/cms.service';
import {Router, ActivatedRoute } from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser'
import {LargeImageDialogComponent} from '../../shared/components/large-image-dialog/large-image-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {PageEvent} from '@angular/material/paginator';
import {DOCUMENT, isPlatformBrowser, Location} from '@angular/common';
import {SeoService} from '../../shared/services/seo.service';
import {WINDOW} from '../../shared/services/window.service';
import {UserDialogComponent} from '../../user-dialog/user-dialog.component';
import {environment} from '../../../environments/environment';
import {BreakpointObserver} from "@angular/cdk/layout";
import {BREAKPOINTS} from "../../shared/constants/breakpoints";
import {Subscription} from "rxjs";

@Component({
    selector: 'mbnm-cms-detail-page',
    providers: [CmsService],
    templateUrl: './cms-detail-page.component.html',
    styleUrls: ['./cms-detail-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CmsDetailPageComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private cms: CmsService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private media: BreakpointObserver,
    public seoService: SeoService,
    @Inject(WINDOW) private window: Window,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object) {
  }

  pageData = null;
  pageType: string;

  @Input()
  tiles: any;

  totalTiles: number;
  postsPerPage: number;
  fragSubscription: any;
  subRef: Subscription;

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const head = this.document.getElementsByTagName('head')[0];
      const global = this.document.createElement('link');
      global.id = 'elementor-global-css';
      global.rel = 'stylesheet';
      global.href = environment.baseUrls().cms + 'elementor/css/global.css';
      head.appendChild(global);

      const frontend = this.document.createElement('link');
      frontend.id = 'elementor-frontend-css';
      frontend.rel = 'stylesheet';
      frontend.href = environment.baseUrls().cms + 'elementor/css/frontend.css';
      head.appendChild(frontend);
    }

    this.subRef = this.route.params
      .subscribe(params => {

        delete this.pageData;
        delete this.tiles;

        this.pageType = params['folder'];
        let slug = params['slug'] ? params['slug'] : null;

        if (this.pageType === 'blog') {
          this.cms
            .postDetails(slug ? slug : '')
            .then((data) => {
              if (data != null) {
                this.pageData = data;
                this.seoService.setMetaData({
                  title: 'Blog - ' +  data.pageTitle + ' - Matboard and More',
                  description: data.metaDescription
                });
                this.cms
                  .posts(1)
                  .then( (d: any) => {
                    this.totalTiles = d.total;
                    this.postsPerPage = d.postsPerPage;
                    this.tiles = d.posts.filter( (dt) => {
                      return dt.id !== this.pageData.id ? dt : null;
                    });
                  });
              }
            }, (err) => {
              this.router.navigateByUrl('/not-found',{ skipLocationChange: true });
            });
        } else {
          this.cms
            .pageDetails(slug)
            .then((data) => {
              this.pageData = data;
              this.seoService.setMetaData({
                title: data.pageTitle,
                description: data.metaDescription
              });
              this.tiles = [];

              if (isPlatformBrowser(this.platformId)) {
                this.fragSubscription = this.route.fragment.subscribe((frag) => {
                  requestAnimationFrame( () => {
                    let el = this.content && this.content.nativeElement && this.content.nativeElement.querySelector('#' + frag);
                    if (el) {
                      this.scrollIntoView(el);
                    }
                  });
                });
              }

              setTimeout( () => {
                const actionButton = this.content && this.content.nativeElement.querySelector('button[data-action]');
                if (actionButton) {
                  actionButton.addEventListener('click', () => {
                    switch (actionButton.dataset.action) {
                      case 'register': {
                        const dialogRef = this.dialog.open(UserDialogComponent);
                        dialogRef.componentInstance.configs = {
                          registerRedirect: '/checkout',
                          view : 'register',
                          closeMethod: 'x'
                        }
                        dialogRef.componentInstance.registerForm.referrer = actionButton.dataset.referrer;
                        dialogRef.componentInstance.registerRedirect = actionButton.dataset.redirect;
                      } break;
                    }
                  });
                }
              });
            }, (err) => {
              this.router.navigateByUrl('/not-found',{ skipLocationChange: true });
            });
        }
      })
  }

  ngOnDestroy() {
    if (this.fragSubscription && !this.fragSubscription.closed) {
      this.fragSubscription.unsubscribe();
    }

    if (this.subRef && !this.subRef.closed) {
      this.subRef.unsubscribe();
    }
  }

  scrollIntoView(el:any) {
    if (isPlatformBrowser(this.platformId)) {
      el.scrollIntoView();
      if (!this.media.isMatched(BREAKPOINTS.Standard.XSmall)) {
        setTimeout(() => {
          this.window.document.scrollingElement.scrollBy(0, -100);
        });
      }
    }
  }

  private findLink(el:any):string {
    if (!el) return null;
    if (el.tagName === 'A') return el.getAttribute('href');
    return this.findLink(el.parentNode);
  }

  @ViewChild('content') content: ElementRef;

  public contentClicked($event: any) {
    const link = this.findLink($event.target);
    if (link) {
      $event.preventDefault();

      if (link.endsWith('.jpg') || link.endsWith('.png')) {
        this.showImage(link);
      } else if (link.startsWith('#')) {
        let el = this.content.nativeElement.querySelector(link);
        if (el) {
          this.scrollIntoView(el);
          this.location.go(this.route.snapshot.url.join('/') + link);
        }
      } else if (link.startsWith('http') || link.startsWith('mailto')) {
        this.window.location.href = link;
      } else {
        if (this.fragSubscription && !this.fragSubscription.closed) {
          this.fragSubscription.unsubscribe();
        }
        this.router.navigateByUrl(link);
      }
    }
  }

  showImage(imageUrl:string) {
    this.dialog.open(LargeImageDialogComponent, {
      maxWidth: '95%',
      data: {
        largeImage: imageUrl
      }
    });
  }

  pageChanged(event: PageEvent) {
    this.tiles = null;
    this.cms
      .posts(event.pageIndex+1)
      .then( (data) => {
        this.tiles = data.posts.filter( (dt) => {
          return dt.id != this.pageData.id ? dt : null;
        });
      });
  }
}
